import { Button, Card, CardActions, CardContent, CardHeader, Divider, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { Link as RouterLink } from "react-router-dom";

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(3),
  },
  content: {
  },
  actions: {
    flexDirection: "column",
    alignItems: "flex-start",
    "& > * + *": {
      marginLeft: 0
    }
  },
  notice: {
    marginTop: theme.spacing(1)
  },
  italics_light: {
    opacity: 0.7,
    fontStyle: "italic",
  },
  spinner: {
    marginTop: theme.spacing(3),
  },
  mono: {
    fontFamily: ["Roboto Mono", "monospace"],
  },
}));

const TeacherPreview = props => {
  const { model, className, ...rest } = props;
  const classes = useStyles();
  if (!model) return null;
  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <CardHeader title="Teacher" />
      <Divider />
      <CardContent className={classes.content}>
        {model && (
          <Fragment>
            <Typography variant="h3">{model.name_en}</Typography>
            <Typography variant="body1" >{model.title}</Typography>
          </Fragment>
        )}
      </CardContent>
      <CardActions className={classes.actions}>
        <Button component={RouterLink} size="small" to={`/teachers/${model.id}/summary`}>
          View Teacher Details
        </Button>
      </CardActions>
    </Card>
  );
};

TeacherPreview.propTypes = {
  className: PropTypes.string,
};

export default TeacherPreview;
